import * as React from "react";
import * as ReactDOM from "react-dom";

import { ItemInfo } from "./components/Item";
import { STRCalculator } from "./components/Calculator";

import { Sidebar } from "./components/Sidebar";
import * as Img from './imagemap';

 
import { Introduction } from "./components/Introduction";
import { Part1 } from "./components/Part1";
import { Part2 } from "./components/Part2";
import { Part3 } from "./components/Part3";
import { Credits } from "./components/Credits";

ReactDOM.render(
    <Introduction/>,
    document.getElementById("introduction")
);
ReactDOM.render(
    <Part1/>,
    document.getElementById("part1")
);
ReactDOM.render(
    <Part2/>,
    document.getElementById("part2")
);
ReactDOM.render(
    <Part3/>,
    document.getElementById("part3")
);
ReactDOM.render(
    <Credits/>,
    document.getElementById("credits")
);

ReactDOM.render(
    <Sidebar/>,
    document.getElementById("sidebar")
)